import { useInstallPrompt } from "../hooks/useInstallPrompt";
import { DownloadOutlined, CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

/**
 * PWA Install Banner — показва се само когато:
 * 1. Браузърът поддържа install prompt (beforeinstallprompt event е наличен)
 * 2. App-ът НЕ е вече отворен в standalone/PWA режим
 */
export default function InstallBanner() {
  const { isInstallable, isStandalone, promptInstall, dismiss } =
    useInstallPrompt();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  // Показваме банера само на login екрана (преди логин)
  if (pathname !== "/login") return null;
  if (isStandalone || !isInstallable) return null;

  return (
    <div
      // плаващ overlay → в тъмна тема получава elevation ниво 1 (виж index.css 7б)
      className="dk-elevated fixed bottom-4 left-4 right-4 z-[9999] mx-auto flex max-w-[420px] flex-col gap-3 overflow-hidden rounded-2xl border border-shade-2 bg-surface px-3.5 pb-3 pt-3.5 shadow-[0_12px_32px_rgba(17,17,17,0.12),0_2px_8px_rgba(17,17,17,0.05)]"
    >
      {/* Decorative amber glow */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_70%_at_100%_0%,var(--color-brand-tint)_0%,transparent_60%)]" />

      {/* Header row */}
      <div className="relative flex items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-shade-2 bg-surface p-1.5 shadow-[0_2px_6px_rgba(17,17,17,0.05)]">
          <img
            src="/icon-192x192.png"
            alt="UnrealSoft"
            className="h-full w-full rounded-lg object-contain"
          />
        </div>

        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold uppercase leading-none tracking-[1.3px] text-brand-deep-ink">
            {t("common.installBannerKicker")}
          </div>
          <div className="mt-1 truncate text-[14.5px] font-bold leading-[1.25] tracking-[-0.2px] text-ink">
            {t("common.installBannerTitle")}
          </div>
          <div className="mt-1 text-xs leading-[1.4] text-body">
            {t("common.installBannerDesc")}
          </div>
        </div>

        <button
          onClick={dismiss}
          aria-label={t("common.close")}
          className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center self-start rounded-lg border-none bg-transparent text-muted transition-colors hover:bg-shade-1 hover:text-ink"
        >
          <CloseOutlined className="text-[13px]" />
        </button>
      </div>

      {/* Install CTA */}
      <button
        onClick={promptInstall}
        className="relative inline-flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-[10px] border-none bg-brand text-[13.5px] font-bold tracking-[-0.2px] text-white transition-colors hover:bg-brand-deep"
      >
        <DownloadOutlined className="text-sm" />
        {t("common.installBannerCta")}
      </button>
    </div>
  );
}
